import React from 'react'
import { ChevronRight } from 'lucide-react'

const Breadcrumb = ({ items, onNavigate }) => {
  return (
    <div className="flex items-center gap-1 text-sm mb-4">
      {items.map((item, index) => (
        <React.Fragment key={item.id}>
          <button
            onClick={() => onNavigate(item.id)}
            className={`hover:text-white transition-colors ${
              index === items.length - 1 
                ? 'text-white font-medium' 
                : 'text-gray-400'
            }`}
          >
            {item.label}
          </button>
          {index < items.length - 1 && (
            <ChevronRight className="w-4 h-4 text-gray-600" />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default Breadcrumb 